import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Format, Lookup, Pager, Paging, Popup } from "devextreme-react/data-grid";
import { GroupItem, Item } from "devextreme-react/form";
import { dataGridErrorHandling, showError } from '../../utils/errorHandling';
import { useAssistitiMalattieDataSource } from '../../datasources/AssistitiMalattieDataSource';
import { useScreenSize } from '../../utils/media-query';

type Props = {
  assistitoId: string;
  onchanged?: () => void;
  readOnly?: boolean;
}

export type AssistitoEditMalattiePanelHandle = {
}

const AssistitoEditMalattiePanel: React.ForwardRefRenderFunction<AssistitoEditMalattiePanelHandle, Props> = (props, ref) => {
  const dataSource = useAssistitiMalattieDataSource(props.assistitoId);
  const gridRef = useRef<DataGridRef>(null);

  return (
    <React.Fragment>
      <DataGrid
        dataSource={dataSource}
        ref={gridRef}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
        onRowInserted={props.onchanged}
        onRowRemoved={props.onchanged}
        onRowUpdated={props.onchanged}
      >
        <Editing
          mode="popup"
          allowUpdating={props.readOnly !== true}
          allowAdding={props.readOnly !== true}
          allowDeleting={props.readOnly !== true}>
          <Popup title="Malattia" showTitle={true} />
          <Form colCount={1}>
            <Item dataField="tipo" editorType='dxTextBox' />
            <Item dataField="sintomi" editorType='dxTextBox' />
            <Item dataField={'terapia'} editorType='dxTextBox' />
            <Item dataField={'note'} editorType='dxTextArea' />
          </Form>
        </Editing>
        <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
        <Column dataField={'tipo'} caption={'Tipo'} />
        <Column dataField={'sintomi'} caption={'Sintomi'} />
        <Column dataField={'terapia'} caption={'Terapia'} />
        <Column dataField={'note'} caption={'Note'} />
      </DataGrid>
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditMalattiePanel);